import { post } from './http'

//获取竞赛规程
export function getRaceRule() {
    return post('/tyapi/pc/groupCockpit/getSportRaceRule', {})
}

//获取竞赛活动
export function getRaceInfo(ruleId){
    return post('/tyapi/pc/groupCockpit/getSportRaceInfo',{
        "ruleId":ruleId})
}
